$(document).ready(() => {
    // Setup the a11y nav
    $('.js-nav-global').setup_navigation();

    // RWD Nav Pattern
    $('body').addClass('js');
    const $menu = $('#menu');
    const $menulink = $('.menu-link');
    const $menuTrigger = $('.has-subnav > a');

    $menulink.click((e) => {
        e.preventDefault();
        $menulink.toggleClass('active');
        $menu.toggleClass('active');
    });

    $menuTrigger.click((e) => {
        e.preventDefault();
        const $el = $(e.currentTarget);
        $el.toggleClass('active').next('ul').toggleClass('active');
    });
});

const keyCodeMap = {
    48: '0', 49: '1', 50: '2', 51: '3', 52: '4', 53: '5', 54: '6', 55: '7', 56: '8', 57: '9', 59: ';', 65: 'a', 66: 'b', 67: 'c', 68: 'd', 69: 'e', 70: 'f', 71: 'g', 72: 'h', 73: 'i', 74: 'j', 75: 'k', 76: 'l', 77: 'm', 78: 'n', 79: 'o', 80: 'p', 81: 'q', 82: 'r', 83: 's', 84: 't', 85: 'u', 86: 'v', 87: 'w', 88: 'x', 89: 'y', 90: 'z', 96: '0', 97: '1', 98: '2', 99: '3', 100: '4', 101: '5', 102: '6', 103: '7', 104: '8', 105: '9',
};

$.fn.setup_navigation = function (setting) {
    const settings = jQuery.extend(
        {
            menuHoverClass: 'show-menu',
            mouseleaveHideDuration: 1000,
        },
        setting
    );

    // Add ARIA role to menubar and menu items
    $(this).attr('role', 'menubar').find('li').attr('role', 'menuitem');

    const topLevelLinks = $(this).find('> li > a');
    // this is set here to make it easy to cancel the setTimeout if the user mouses back in
    let mouseleaveTimer;

    // Added by Terrill: (removed temporarily: doesn't fix the JAWS problem after all)
    // Add tabindex="0" to all top-level links
    // Without at least one of these, JAWS doesn't read widget as a menu, despite all the other ARIA
    // $(topLevelLinks).attr('tabindex','0');

    // Set tabIndex to -1 so that topLevelLinks can't receive focus until menu is open
    $(topLevelLinks)
        .next('ul')
        .attr('data-test', 'true')
        .attr({ 'aria-hidden': 'true', role: 'menu' })
        .find('a')
        .attr('tabIndex', -1);

    // Adding aria-haspopup for appropriate items
    $(topLevelLinks).each((e) => {
        const $el = $(e.currentTarget);
        if ($el.next('ul').length > 0) $el.parent('li').attr('aria-haspopup', 'true');
    });

    $(topLevelLinks).hover((e) => {
        const $el = $(e.currentTarget);
        // cancel any setTimeout that may be preparing to hide the menu due to mouseleave function
        clearTimeout(mouseleaveTimer);
        $el.closest('ul')
            .attr('aria-hidden', 'false')
            .find(`.${settings.menuHoverClass}`)
            .attr('aria-hidden', 'true')
            .removeClass(settings.menuHoverClass)
            .find('a')
            .attr('tabIndex', -1);
        $el.next('ul').attr('aria-hidden', 'false').addClass(settings.menuHoverClass).find('a').attr('tabIndex', 0);
    });

    $(topLevelLinks)
        .parent('li')
        .mouseleave(() => {
            mouseleaveTimer = setTimeout(() => {
                $(`.${settings.menuHoverClass}`)
                    .attr('aria-hidden', 'true')
                    .removeClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', -1);
            }, settings.mouseleaveHideDuration);
        });

    $(topLevelLinks).focus((e) => {
        const $el = $(e.currentTarget);
        $el.closest('ul')
            // Removed by Terrill
            // The following was adding aria-hidden="false" to root ul since menu is never hidden
            // and seemed to be causing flakiness in JAWS (needs more testing)
            // .attr('aria-hidden', 'false')
            .find(`.${settings.menuHoverClass}`)
            .attr('aria-hidden', 'true')
            .removeClass(settings.menuHoverClass)
            .find('a')
            .attr('tabIndex', -1);

        $el.next('ul').attr('aria-hidden', 'false').addClass(settings.menuHoverClass).find('a').attr('tabIndex', 0);
    });

    // Bind arrow keys for navigation
    $(topLevelLinks).keydown((e) => {
        const $el = $(e.currentTarget);
        if (e.keyCode === 37) {
            e.preventDefault();
            // This is the first item
            if ($el.parent('li').prev('li').length === 0) {
                $el.parents('ul').find('> li').last().find('a').first().focus();
            } else {
                $el.parent('li').prev('li').find('a').first().focus();
            }
        } else if (e.keyCode === 38) {
            e.preventDefault();
            if ($el.parent('li').find('ul').length > 0) {
                $el.parent('li')
                    .find('ul')
                    .attr('aria-hidden', 'false')
                    .addClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', 0)
                    .last()
                    .focus();
            }
        } else if (e.keyCode === 39) {
            e.preventDefault();
            // This is the last item
            if ($el.parent('li').next('li').length === 0) {
                $el.parents('ul').find('> li').first().find('a').first().focus();
            } else {
                $el.parent('li').next('li').find('a').first().focus();
            }
        } else if (e.keyCode === 40) {
            e.preventDefault();
            if ($el.parent('li').find('ul').length > 0) {
                $el.parent('li')
                    .find('ul')
                    .attr('aria-hidden', 'false')
                    .addClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', 0)
                    .first()
                    .focus();
            }
        } else if (e.keyCode === 13 || e.keyCode === 32) {
            // If submenu is hidden, open it
            e.preventDefault();
            $el.parent('li')
                .find('ul[aria-hidden=true]')
                .attr('aria-hidden', 'false')
                .addClass(settings.menuHoverClass)
                .find('a')
                .attr('tabIndex', 0)
                .first()
                .focus();
        } else if (e.keyCode === 27) {
            e.preventDefault();
            $(`.${settings.menuHoverClass}`)
                .attr('aria-hidden', 'true')
                .removeClass(settings.menuHoverClass)
                .find('a')
                .attr('tabIndex', -1);
        } else {
            $el.parent('li')
                .find('ul[aria-hidden=false] a')
                .each((e1) => {
                    const $el1 = $(e1.currentTarget);
                    if ($el1.text().substring(0, 1).toLowerCase() === keyCodeMap[e.keyCode]) {
                        $el1.focus();
                        return false;
                    }
                    return true;
                });
        }
    });

    const links = $(topLevelLinks).parent('li').find('ul').find('a');
    $(links).keydown((e) => {
        const $el = $(e.currentTarget);
        if (e.keyCode === 38) {
            e.preventDefault();
            // This is the first item
            if ($el.parent('li').prev('li').length === 0) {
                $el.parents('ul').parents('li').find('a').first().focus();
            } else {
                $el.parent('li').prev('li').find('a').first().focus();
            }
        } else if (e.keyCode === 40) {
            e.preventDefault();
            if ($el.parent('li').next('li').length === 0) {
                $el.parents('ul').parents('li').find('a').first().focus();
            } else {
                $el.parent('li').next('li').find('a').first().focus();
            }
        } else if (e.keyCode === 27 || e.keyCode === 37) {
            e.preventDefault();
            $el.parents('ul')
                .first()
                .prev('a')
                .focus()
                .parents('ul')
                .first()
                .find(`.${settings.menuHoverClass}`)
                .attr('aria-hidden', 'true')
                .removeClass(settings.menuHoverClass)
                .find('a')
                .attr('tabIndex', -1);
        } else if (e.keyCode === 32) {
            e.preventDefault();
            window.location = $el.attr('href');
        } else {
            let found = false;
            $el.parent('li')
                .nextAll('li')
                .find('a')
                .each((e1) => {
                    const $el1 = $(e1.currentTarget);
                    if ($el1.text().substring(0, 1).toLowerCase() === keyCodeMap[e.keyCode]) {
                        $el1.focus();
                        found = true;
                        return false;
                    }
                    return true;
                });

            if (!found) {
                $el.parent('li')
                    .prevAll('li')
                    .find('a')
                    .each((e1) => {
                        const $el1 = $(e1.currentTarget);
                        if ($el1.text().substring(0, 1).toLowerCase() === keyCodeMap[e.keyCode]) {
                            $el1.focus();
                            return false;
                        }
                        return true;
                    });
            }
        }
    });

    // Hide menu if click or focus occurs outside of navigation
    $(this)
        .find('a')
        .last()
        .keydown((e) => {
            if (e.keyCode === 9) {
                // If the user tabs out of the navigation hide all menus
                $(`.${settings.menuHoverClass}`)
                    .attr('aria-hidden', 'true')
                    .removeClass(settings.menuHoverClass)
                    .find('a')
                    .attr('tabIndex', -1);
            }
        });

    $(document).click(() => {
        $(`.${settings.menuHoverClass}`)
            .attr('aria-hidden', 'true')
            .removeClass(settings.menuHoverClass)
            .find('a')
            .attr('tabIndex', -1);
    });

    $(this).click((e) => {
        e.stopPropagation();
    });
};
